export const previousAlertAction = {
  setDateFilter: (state, action) => {
    state.dateFilter = action.payload;
  },
  setAlertFilter: (state, action) => {
    state.alertFilter = action.payload;
  },
  resetAlertFilters: (state, _action) => {
    state.alertFilter = "All";
    state.dateFilter = "All";
    state.selectedAlert = null;
    state.openPdfModal = false;
  },
  setSelectedAlert: (state, action) => {
    state.selectedAlert = action.payload;
  },
};
